import { Anchor, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { useT } from '../i18n/useT.js';

export function NotFoundPage(): ReactNode {
  const t = useT();

  return (
    <Stack gap="md">
      <Title order={2}>{t('notFound.title')}</Title>
      <Text c="dimmed">{t('notFound.detail')}</Text>
      <Anchor component={Link} to="/">
        {t('notFound.back')}
      </Anchor>
    </Stack>
  );
}
